const TaskApis =  {
  list: '/api/v2/store/task/list',
  getGift: '/api/v2/store/task/gift/receive',
  quickGet: '/api/v2/store/task/gift/receive-all'
}

export default (request) => {
  return {
    getList: (params) => {
      return request.get(TaskApis.list, { params })
    },
    getGift(data) {
      return request.post(TaskApis.getGift, data)
    },
    quickGet(data) {
      return request.post(TaskApis.quickGet, data)
    }
  }
}
